/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import Toolbar from "../../../../components/tasklayout/toolbar/Toolbar";
import Viewbar from "../../../../components/tasklayout/toolbar/features/viewbar/Viewbar";
import { TASK_GRID_SELECTION_MODE } from "../../../../components/tasks/NewTaskGrid";
import SwalAlert from "../../../../services/swalService/SwalService";
import ToastService from "../../../../services/toastService/ToastService";
import { getTeamPlanningMessageType, isTeamPlanningSuccessMessage } from "../../utils/teamPlanningResponse";
import { normalizeUniquePlanningTasks } from "../../utils/normalizePlanningTasks";
import { TaskPageEnums } from "../../../../utils/Enums/TaskPageEnums";
import { useTaskFilter } from "../../../../utils/Context/TaskFilterContext";
import { useGetAllTeamProjectListMutation } from "../../../../app/services/teamProjectsAPI";
import { useGetAllTaskByTeamPlanningIdMutation } from "../../../../app/services/teamboardAPI";
import { useDeleteTeamPlanningTaskByIdMutation } from "../../../../app/services/teamPlanningAPI";

const PlannedTasks = (props) => {
  const teamPlanningId = props.teamData.planningId;
  const teamId = props.teamData.teamId;
  const isReadOnly = props.isReadOnly === true;

  const [projectData, setProjectData] = useState([]);
  const { confirmWithTextarea } = SwalAlert();
  const [taskList, setTaskList] = useState([]);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [searchText, setSearchText] = useState("");
  const { filterRequest, resetFilters } = useTaskFilter();

  const [getAllTeamProjectList, {
    isSuccess: isTeamProjectListSuccess,
    data: isTeamProjectListData,
  }] = useGetAllTeamProjectListMutation();

  const [removeTeamPlanningTask, {
    isSuccess: isTeamPlanningTaskDeleted,
    data: DeleteTeamPlanningTasdkDeleted,
  }] = useDeleteTeamPlanningTaskByIdMutation();

  const [getAllTaskByTeamPlanningId, {
    isLoading: isTaskByTeamPlanningIdLoading,
    isFetching: isTaskByTeamPlanningIdFetching,
    isSuccess: isTaskByTeamPlanningId,
    data: TaskByTeamPlanningIddata,
  }] = useGetAllTaskByTeamPlanningIdMutation();

  const getTeamPlanningDataList = () => {
    getAllTeamProjectList({
      pagination: { pageNumber: 1, pageSize: 10 },
      filters: { searchText: "" },
      teamId,
    });
  };

  const handleRefreshGrid = () => {
    getAllTaskByTeamPlanningId({
      teamPlanningId,
      filterData: JSON.stringify(filterRequest || []),
    });
  };

  const refreshPlanningCount = () => {
    if (props.onPlanningDataChanged) {
      props.onPlanningDataChanged();
      return;
    }
    if (props.getResourceTotalPlanningCount && teamId && teamPlanningId) {
      props.getResourceTotalPlanningCount({ teamId, planningId: teamPlanningId });
    }
  };

  useEffect(() => {
    if (teamPlanningId) {
      getAllTaskByTeamPlanningId({
        teamPlanningId,
        filterData: JSON.stringify(filterRequest || []),
      });
    }
  }, [teamPlanningId, filterRequest]);

  useEffect(() => {
    if (teamId) {
      getTeamPlanningDataList();
    }
  }, [teamId]);

  useEffect(() => {
    if (!isTaskByTeamPlanningIdFetching && isTaskByTeamPlanningId && TaskByTeamPlanningIddata) {
      setHasLoadedOnce(true);
      setTaskList(normalizeUniquePlanningTasks(TaskByTeamPlanningIddata));
    }
  }, [isTaskByTeamPlanningIdFetching, isTaskByTeamPlanningId, TaskByTeamPlanningIddata]);

  useEffect(() => {
    if (isTeamProjectListSuccess && isTeamProjectListData) {
      setProjectData(isTeamProjectListData.dataSource || []);
    }
  }, [isTeamProjectListSuccess, isTeamProjectListData]);

  useEffect(() => {
    if (isTeamPlanningTaskDeleted && DeleteTeamPlanningTasdkDeleted) {
      const message = DeleteTeamPlanningTasdkDeleted.errorMessage;
      ToastService[getTeamPlanningMessageType(message)](message);
      if (!isTeamPlanningSuccessMessage(message)) return;

      getAllTaskByTeamPlanningId({
        teamPlanningId,
        filterData: JSON.stringify(filterRequest || []),
      });
      refreshPlanningCount();
    }
  }, [isTeamPlanningTaskDeleted, DeleteTeamPlanningTasdkDeleted]);

  const handleRemoveTask = (taskData) => {
    if (isReadOnly) return;
    confirmWithTextarea(
      "Confirm Remove Task?",
      "",
      "Please enter Reason to Remove Task",
      "Reason is required",
      "Remove",
      "Cancel"
    )
      .then(({ inputText, isConfirmed }) => {
        if (isConfirmed && inputText) {
          removeTeamPlanningTask({
            taskId: taskData.taskId ?? taskData.id,
            planningId: teamPlanningId,
            reasonText: inputText,
          });
        }
      })
      .catch((error) => {
        console.error("Error in deleteting task:", error);
      });
  };

  const projectId = projectData[0]?.projectId || taskList[0]?.projectId || 0;
  const isInitialLoad = isTaskByTeamPlanningIdLoading && !hasLoadedOnce;
  const hasActiveFilters = (filterRequest || []).length > 0;
  const filteredTasks = searchText
    ? taskList.filter((task) => {
        const needle = searchText.toLowerCase();
        return (
          String(task.taskId ?? "").toLowerCase().includes(needle) ||
          String(task.title ?? "").toLowerCase().includes(needle)
        );
      })
    : taskList;

  return (
    <div className="col-12">
      <Viewbar
        projectId={projectId}
        showCompleted={false}
        onToggleChange={() => {}}
        onSearchChange={setSearchText}
        taskFilterPageId={TaskPageEnums.TEAM_PLANNED_TASK}
      />
      <Toolbar
        listOnly
        projectId={projectId}
        taskListData={filteredTasks}
        isTeamPlanning={true}
        onRemoveTask={isReadOnly ? undefined : handleRemoveTask}
        allowEditStatus={!isReadOnly && Boolean(projectId)}
        allowEditAssignee={!isReadOnly && Boolean(projectId)}
        isShowActualTime={false}
        isShowRemainingTime={true}
        isDataLoading={isInitialLoad}
        isRefreshing={isTaskByTeamPlanningIdFetching && hasLoadedOnce}
        onRefreshGrid={handleRefreshGrid}
        onClearFilters={resetFilters}
        hasActiveFilters={hasActiveFilters}
        hasActiveSearch={Boolean(searchText)}
        selectionMode={isReadOnly ? undefined : TASK_GRID_SELECTION_MODE.BULK}
      />
    </div>
  );
};

export default PlannedTasks;
